import {
  Directive,
  ElementRef,
  HostListener,
  Renderer2,
  inject,
} from '@angular/core';

/** Strips any non-numeric characters from an input as the user types. */
@Directive({
  selector: '[libNumericOnly]',
})
export class NumericOnlyDirective {
  private readonly el = inject(ElementRef);
  private readonly renderer = inject(Renderer2);

  @HostListener('input') onInputChange(): void {
    const input: string = this.el.nativeElement.value.replace(/\D/g, '');
    this.renderer.setProperty(this.el.nativeElement, 'value', input);
  }
}
